module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-shadow-1.477576d3.png";